import { z } from 'zod';
import { defineForm } from '../registry.js';
import { CONFIRMERS, idString, longtext } from './common.js';

// モニタリング（月 1 件）。旧: MonitoringRecord（targetMonth / overallComment / goals[]）。
// 目標は第2表の短期目標（stGoal）の ID を指す。
// 文章の上限は旧 API に無い（エージェントは総括・コメントとも 500）。ここは API 側に合わせ上限なし。
// 旧の goals[].isChanged は下書きの印なので本文に入れない

export const ACHIEVEMENT_STATUSES = ['achieved', 'partial', 'not_achieved', 'unknown'] as const;
export type GoalAchievementStatus = (typeof ACHIEVEMENT_STATUSES)[number];
// 旧 Web の ACHIEVEMENT_LABELS
export const ACHIEVEMENT_LABELS: Record<GoalAchievementStatus, string> = {
  achieved: '達成',
  partial: '一部達成',
  not_achieved: '未達成',
  unknown: '不明',
};

export const monitoringGoalSchema = z
  .object({
    goalId: idString.describe('短期目標ID（第2表）'),
    // 旧 API の入力には無く、保存時に既存の値か goalId で埋めていた
    title: z.string().optional().describe('目標'),
    achievementStatus: z.enum(ACHIEVEMENT_STATUSES).meta({ optionLabels: ACHIEVEMENT_LABELS }).describe('達成状況'),
    comment: longtext('コメント').optional(),
    evidenceEventIds: z.array(idString).optional().describe('根拠の記録ID'),
    evidenceFacilityNoteIds: z.array(idString).optional().describe('根拠の施設記録ID'),
  })
  .strict();

export const monitoringSchema = z
  .object({
    targetMonth: z.string().regex(/^\d{4}-\d{2}$/, 'YYYY-MM で入力してください').describe('対象月'),
    overallComment: longtext('総括').min(1),
    goals: z.array(monitoringGoalSchema).min(1).describe('目標ごとの評価'),
  })
  .strict();
export type MonitoringBody = z.infer<typeof monitoringSchema>;

export const monitoringForm = defineForm({
  app: 'caremanager',
  docType: 'monitoring',
  name: 'モニタリング',
  version: 1,
  schema: monitoringSchema,
  confirmers: CONFIRMERS,
  description: '月ごとに短期目標の達成状況を評価する',
});
